import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { DocumentRequirementsService } from '../document-requirements.service';
import { DefaultSnackBarService } from '../../../services/default-snack-bar.service';
import DocGroupLog from 'src/app/interfaces/doc-group-log';
import { Subscription } from "rxjs";

@Component({
    selector: 'app-initialize-tracker-dialog',
    templateUrl: './initialize-tracker-dialog.component.html',
    styleUrls: ['./initialize-tracker-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class InitializeTrackerDialogComponent {
  date: null | string = null;
  lastRun: DocGroupLog | null = null;

  sub: Subscription;
  constructor(
    public dialogRef: MatDialogRef<InitializeTrackerDialogComponent>,
    public requirementService: DocumentRequirementsService,
    private _snackBar: DefaultSnackBarService
  ) {}

  ngOnInit() {
    this.sub = this.requirementService.newRowsRuns$.subscribe((runs) =>{
      if(runs.length)
        this.lastRun = runs[0];
    })
  }
  public initialize() {
    if (this.date?.length === 4) {
      this.requirementService.initializeTracker(this.date).subscribe(() => {
        this._snackBar.open('Initialized tax season documents');
        this.dialogRef.close();
      });
    }
  }
  ngOnDestroy() {
    this.sub?.unsubscribe();
  }
}
